"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFdrAutocompleteContext = exports.FdrAutocompleteConsumer = exports.FdrAutocompleteProvider = exports.fdrAutocompleteReducer = exports.FdrAutocompleteActionType = exports.FdrAutocompleteContext = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const use_effect_reducer_1 = require("use-effect-reducer");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const initialAutocompleteState = {
    value: '',
    pagination: undefined,
    pageNumberExpected: 0,
    loading: false,
    suggestions: [],
    maxItems: 0,
    selectedItems: [],
    selectedSuggestion: null,
    isSuggestionsOpened: false,
    isLastToRemove: false,
};
exports.FdrAutocompleteContext = (0, react_1.createContext)(Object.assign(Object.assign({}, initialAutocompleteState), { inputRef: react_1.default.createRef(), externalSelectedItems: undefined, setValue: noop_1.default, setLoading: noop_1.default, focusInput: noop_1.default, focusNext: noop_1.default, focusPrev: noop_1.default, pickFocused: noop_1.default, setSuggestions: noop_1.default, updateSuggestion: noop_1.default, openSuggestions: noop_1.default, closeSuggestions: noop_1.default, setSelected: noop_1.default, selectItem: noop_1.default, removeItem: noop_1.default, backspace: noop_1.default, nextPage: noop_1.default }));
var FdrAutocompleteActionType;
(function (FdrAutocompleteActionType) {
    FdrAutocompleteActionType["SET_VALUE"] = "SET_VALUE";
    FdrAutocompleteActionType["SET_SUGGESTIONS"] = "SET_SUGGESTIONS";
    FdrAutocompleteActionType["UPDATE_SUGGESTION"] = "UPDATE_SUGGESTION";
    FdrAutocompleteActionType["SET_LOADING"] = "SET_LOADING";
    FdrAutocompleteActionType["OPEN_SUGGESTIONS"] = "OPEN_SUGGESTIONS";
    FdrAutocompleteActionType["CLOSE_SUGGESTIONS"] = "CLOSE_SUGGESTIONS";
    FdrAutocompleteActionType["FOCUS_NEXT"] = "FOCUS_NEXT";
    FdrAutocompleteActionType["FOCUS_PREV"] = "FOCUS_PREV";
    FdrAutocompleteActionType["PICK_FOCUSED"] = "PICK_FOCUSED";
    FdrAutocompleteActionType["SET_MAX_ITEMS"] = "SET_MAX_ITEMS";
    FdrAutocompleteActionType["SET_SELECTED"] = "SET_SELECTED";
    FdrAutocompleteActionType["SELECT_ITEM"] = "SELECT_ITEM";
    FdrAutocompleteActionType["REMOVE_ITEM"] = "REMOVE_ITEM";
    FdrAutocompleteActionType["BACKSPACE"] = "BACKSPACE";
    FdrAutocompleteActionType["NEXT_PAGE"] = "NEXT_PAGE";
})(FdrAutocompleteActionType || (exports.FdrAutocompleteActionType = FdrAutocompleteActionType = {}));
function fdrAutocompleteReducer(prevState, action, exec) {
    var _a;
    switch (action.type) {
        case FdrAutocompleteActionType.SET_VALUE: {
            return Object.assign(Object.assign({}, prevState), { selectedSuggestion: null, value: action.value, suggestions: [], pagination: undefined, pageNumberExpected: 0, isLastToRemove: false });
        }
        case FdrAutocompleteActionType.SET_SUGGESTIONS: {
            return Object.assign(Object.assign({}, prevState), { suggestions: action.suggestions, pagination: action.pagination, pageNumberExpected: action.pagination ? action.pagination.page : 0 });
        }
        case FdrAutocompleteActionType.UPDATE_SUGGESTION: {
            return Object.assign(Object.assign({}, prevState), { suggestions: prevState.suggestions.map((item, index) => {
                    return index === action.index ? action.newSuggestion : item;
                }) });
        }
        case FdrAutocompleteActionType.SET_LOADING: {
            return Object.assign(Object.assign({}, prevState), { loading: action.loading });
        }
        case FdrAutocompleteActionType.OPEN_SUGGESTIONS: {
            return Object.assign(Object.assign({}, prevState), { isSuggestionsOpened: true });
        }
        case FdrAutocompleteActionType.CLOSE_SUGGESTIONS: {
            return Object.assign(Object.assign({}, prevState), { isSuggestionsOpened: false });
        }
        case FdrAutocompleteActionType.FOCUS_NEXT: {
            const { suggestions, selectedSuggestion: prevIndex } = prevState;
            const nextIndex = typeof prevIndex === 'number' ? prevIndex + 1 : 0;
            const maxIndex = suggestions.length - 1;
            const selectedSuggestion = nextIndex > maxIndex ? null : nextIndex;
            return Object.assign(Object.assign({}, prevState), { selectedSuggestion });
        }
        case FdrAutocompleteActionType.FOCUS_PREV: {
            const { suggestions, selectedSuggestion: prevIndex } = prevState;
            const nextIndex = (prevIndex || 0) - 1;
            const selectedSuggestion = prevIndex === null ? suggestions.length - 1 : nextIndex;
            return Object.assign(Object.assign({}, prevState), { selectedSuggestion });
        }
        case FdrAutocompleteActionType.SET_MAX_ITEMS: {
            let { selectedItems } = prevState;
            const { maxItems } = action;
            if (maxItems) {
                selectedItems = selectedItems.slice(-maxItems);
            }
            return Object.assign(Object.assign({}, prevState), { maxItems,
                selectedItems });
        }
        case FdrAutocompleteActionType.PICK_FOCUSED: {
            const { maxItems, suggestions, selectedSuggestion: candidat, selectedItems: prevItems, } = prevState;
            const suggestion = suggestions[candidat || 0];
            const shouldRemoveItems = action.noTags && !suggestion && !prevState.value && prevItems.length;
            // Check that no suggestions in autocomplete
            // Check that input is empty and selected items exist
            // If so, remove all selected items
            if (shouldRemoveItems) {
                exec({ type: 'onSelectedChange', selectedItems: [] });
                return Object.assign(Object.assign({}, prevState), { selectedItems: [], selectedSuggestion: null });
            }
            if (suggestion) {
                let selectedItems = [...prevItems, suggestion];
                if (maxItems) {
                    selectedItems = selectedItems.slice(-maxItems);
                }
                exec({
                    type: 'onItemSelect',
                    options: {
                        item: suggestion,
                        value: prevState.value,
                    },
                });
                exec({ type: 'onSelectedChange', selectedItems });
                return Object.assign(Object.assign({}, prevState), { value: action.noTags
                        ? selectedItems.map(s => s.name).join()
                        : '', selectedItems, selectedSuggestion: null });
            }
            return Object.assign(Object.assign({}, prevState), { selectedSuggestion: null });
        }
        case FdrAutocompleteActionType.SET_SELECTED: {
            const { maxItems } = prevState;
            let { selectedItems } = action;
            if (!action.ignoreMaxItems && maxItems) {
                selectedItems = selectedItems.slice(-maxItems);
            }
            !action.ignoreMaxItems &&
                exec({ type: 'onSelectedChange', selectedItems });
            return Object.assign(Object.assign({}, prevState), { selectedItems: action.selectedItems });
        }
        case FdrAutocompleteActionType.SELECT_ITEM: {
            const { selectedItems: prevItems, maxItems } = prevState;
            let selectedItems = [...prevItems, action.item];
            if (maxItems) {
                selectedItems = selectedItems.slice(-maxItems);
            }
            exec({ type: 'onSelectedChange', selectedItems });
            exec({
                type: 'onItemSelect',
                options: {
                    item: action.item,
                    value: prevState.value,
                },
            });
            return Object.assign(Object.assign({}, prevState), { selectedItems, value: '' });
        }
        case FdrAutocompleteActionType.REMOVE_ITEM: {
            const { selectedItems: prevItems, maxItems } = prevState;
            let selectedItems = prevItems.filter(item => item !== action.item);
            if (maxItems) {
                selectedItems = selectedItems.slice(-maxItems);
            }
            exec({ type: 'onSelectedChange', selectedItems });
            exec({ type: 'onItemRemove', option: action.item });
            return Object.assign(Object.assign({}, prevState), { selectedItems });
        }
        case FdrAutocompleteActionType.BACKSPACE: {
            const nextState = Object.assign({}, prevState);
            if (prevState.value === '' && !action.noTags) {
                if (prevState.isLastToRemove) {
                    nextState.selectedItems = prevState.selectedItems.slice(0, -1);
                    exec({
                        type: 'onSelectedChange',
                        selectedItems: nextState.selectedItems,
                    });
                    nextState.isLastToRemove = false;
                }
                else {
                    nextState.isLastToRemove = true;
                }
            }
            if (action.noTags) {
                const inputValuesCount = nextState.value.split(', ').length;
                const selectedValuesCount = nextState.selectedItems.length;
                if (selectedValuesCount && inputValuesCount !== selectedValuesCount) {
                    nextState.selectedItems = prevState.selectedItems.slice(0, -1);
                    exec({
                        type: 'onSelectedChange',
                        selectedItems: nextState.selectedItems,
                    });
                }
            }
            return nextState;
        }
        case FdrAutocompleteActionType.NEXT_PAGE: {
            return Object.assign(Object.assign({}, prevState), { 
                // increase current data page
                pageNumberExpected: (((_a = prevState.pagination) === null || _a === void 0 ? void 0 : _a.page) || 0) + 1 });
        }
    }
    return prevState;
}
exports.fdrAutocompleteReducer = fdrAutocompleteReducer;
function FdrAutocompleteProvider(props) {
    const { contextRef, maxItems = 0, onSelectedChange = noop_1.default, onItemSelect = noop_1.default, onItemRemove = noop_1.default, valueInterceptor = value => value, selectedItems, children, } = props;
    const inputRef = (0, react_1.useRef)(null);
    // Access items handlers by refs to avoid context handlers change
    const valueInterceptorRef = (0, libs_hooks_react_1.useSelfUpdatingRef)(valueInterceptor);
    const [state, dispatch] = (0, use_effect_reducer_1.useEffectReducer)(fdrAutocompleteReducer, Object.assign(Object.assign({}, initialAutocompleteState), { maxItems, selectedItems: selectedItems || [] }), {
        onSelectedChange(_, effect) {
            const { selectedItems: changedItems, } = effect;
            onSelectedChange(changedItems);
        },
        onItemSelect(_, effect) {
            const { options } = effect;
            onItemSelect(options);
        },
        onItemRemove(_, effect) {
            const { option } = effect;
            onItemRemove(option);
        },
    });
    (0, react_1.useEffect)(function updateMaxItemsEffect() {
        dispatch({ type: FdrAutocompleteActionType.SET_MAX_ITEMS, maxItems });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [maxItems]);
    const handlers = (0, react_1.useMemo)(() => ({
        setValue(value) {
            dispatch({
                type: FdrAutocompleteActionType.SET_VALUE,
                value: valueInterceptorRef.current(value),
            });
        },
        setSuggestions(suggestions, pagination) {
            dispatch({
                type: FdrAutocompleteActionType.SET_SUGGESTIONS,
                suggestions,
                pagination,
            });
        },
        updateSuggestion(index, newSuggestion) {
            dispatch({
                type: FdrAutocompleteActionType.UPDATE_SUGGESTION,
                index,
                newSuggestion,
            });
        },
        nextPage() {
            dispatch({ type: FdrAutocompleteActionType.NEXT_PAGE });
        },
        setLoading(loading) {
            dispatch({
                type: FdrAutocompleteActionType.SET_LOADING,
                loading,
            });
        },
        focusInput(options) {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(options);
        },
        focusNext() {
            dispatch({ type: FdrAutocompleteActionType.FOCUS_NEXT });
        },
        focusPrev() {
            dispatch({ type: FdrAutocompleteActionType.FOCUS_PREV });
        },
        pickFocused(noTags) {
            dispatch({ type: FdrAutocompleteActionType.PICK_FOCUSED, noTags });
        },
        openSuggestions() {
            dispatch({ type: FdrAutocompleteActionType.OPEN_SUGGESTIONS });
        },
        closeSuggestions() {
            dispatch({ type: FdrAutocompleteActionType.CLOSE_SUGGESTIONS });
        },
        setSelected(nextItems, ignoreMaxItems) {
            dispatch({
                type: FdrAutocompleteActionType.SET_SELECTED,
                selectedItems: nextItems,
                ignoreMaxItems,
            });
        },
        selectItem(item) {
            dispatch({ type: FdrAutocompleteActionType.SELECT_ITEM, item });
        },
        removeItem(item) {
            dispatch({ type: FdrAutocompleteActionType.REMOVE_ITEM, item });
        },
        backspace(noTags) {
            dispatch({ type: FdrAutocompleteActionType.BACKSPACE, noTags });
        },
    }), 
    // Handlers are not changing during the time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const context = (0, react_1.useMemo)(() => (Object.assign(Object.assign(Object.assign(Object.assign({}, state), { inputRef }), handlers), { externalSelectedItems: selectedItems })), [handlers, selectedItems, state]);
    if (contextRef) {
        contextRef.current = context;
    }
    return (react_1.default.createElement(exports.FdrAutocompleteContext.Provider, { value: context }, children));
}
exports.FdrAutocompleteProvider = FdrAutocompleteProvider;
function FdrAutocompleteConsumer(props) {
    return (react_1.default.createElement(exports.FdrAutocompleteContext.Consumer, null, props.children));
}
exports.FdrAutocompleteConsumer = FdrAutocompleteConsumer;
function useFdrAutocompleteContext() {
    return (0, react_1.useContext)(exports.FdrAutocompleteContext);
}
exports.useFdrAutocompleteContext = useFdrAutocompleteContext;
//# sourceMappingURL=fdr-autocomplete.context.js.map